export default __webpack_public_path__ + "static/media/a017-line5.4f6e859b.svg";